module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"budgetsTable.noBudgets":"There are no budgets yet.","budgetsTable.loadingBudgets":"Loading budgets","budgetsTable.name":"Budget Name","budgetsTable.amount":"Budget Amount","budgetsTable.view":"View","budgetsTable.progress":"Progress","budgetsTable.actual":"Current Spend","budgetsTable.projections":"Forecast","budgetsTable.actions":"Actions"}}')
  delete Component.options._Ctor
}
